<template>
	<!-- <div class="banner container"> -->
	<div class="banner">
		<el-carousel arrow="always">
			<el-carousel-item v-for="(item,index) in bannerData" :key="index" >
				<img :src="item.img" alt=""  @click="go(item)">
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	import goBanner from './goBanner.js'
	export default {
		mixins: [
			goBanner
		],
		props:{
			componentId:{
				type:String,
				default:""
			}
		},
		data() {
			return {
				bannerData:[]
			}
		},
		created(){
			this.getData()
		},
		methods: {
			getData(){
				let that = this
				that.$server.post("/index.php/AppInterface/IndexModule11/index" , {
					id: that.componentId,
				})
				.then(res => {
					switch (res.result) {
						case 1:
							that.bannerData = res.data.index_arr.item_arr||[]
							break;
						default:
							uni.showToast({
								icon: "none",
								title: res.data.msg
							});
							break;
					}
				})
			},
			go(item) {
				this.relevance_type = item.type
				this.relevance_id = item.item_id
				this.goBanner()
			}
		}
	}
</script>

<style lang="scss">
	@mixin flex_01() {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.banner {
		width: 100%;
		margin: 0 auto;
		
		.el-carousel__container{
			@include flex_01();
			
			position: static;
			// height: 600px;
			/** 1920x460 */
			// height: 23.9583vw;
			$img-H: 460px;
			height: $img-H;
			
			.el-carousel__arrow {
				display: flex;
				justify-content: center;
				align-items: center;
				box-sizing: border-box;
				width: 48px;
				height: 48px;
				padding-left: 0px;
				font-size: 28px;
				
				&--left {
					// left: 0;
				}
				&--right {
					// right: 0;
				}
			}
			.el-carousel__item {
				@include flex_01();
				
				cursor: pointer;
				
				img{
					display: block;
					width: 100%;
					// height: 100%;
					height: $img-H;
					object-fit: cover;
				}
			}
		}
		.el-carousel__indicators {
			& > .el-carousel__indicator {
				$pad: 6px;
				padding-left: $pad;
				padding-right: $pad;
				
				& > button {
					height: 3px;
					background-color: #aaaaaaaa;
				}
			}
			& > .is-active {
				& > button {
					background-color: #333333aa;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/modular/banner.vue